import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Layout/Navbar';
import LoginForm from './components/Auth/LoginForm';
import RegisterForm from './components/Auth/RegisterForm';
import RestaurantList from './components/Restaurant/RestaurantList';
import RestaurantMenu from './components/Restaurant/RestaurantMenu';
import CreateSession from './components/Session/CreateSession';
import SessionDetail from './components/Session/SessionDetail';
import PublicBill from './components/Session/PublicBill';
import AdminPanel from './components/Admin/AdminPanel';
import NotFound from './components/Layout/NotFound';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</p>;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const PublicOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</p>;
  return isAuthenticated ? <Navigate to="/" /> : <>{children}</>;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnlyRoute><LoginForm /></PublicOnlyRoute>} />
      <Route path="/register" element={<PublicOnlyRoute><RegisterForm /></PublicOnlyRoute>} />
      <Route path="/bill/:sessionId/:memberId" element={<PublicBill />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RestaurantList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/restaurants"
        element={
          <ProtectedRoute>
            <RestaurantList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/restaurants/:id/menu"
        element={
          <ProtectedRoute>
            <RestaurantMenu />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/new"
        element={
          <ProtectedRoute>
            <CreateSession />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions/:id"
        element={
          <ProtectedRoute>
            <SessionDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <main>
          <AppRoutes />
        </main>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
